/**
 * Determine if there are sections in the DOM
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasSections = state => state.data.sections.length > 0

/**
 * Return the branding or default branding from the account
 *
 * @param  {Object} state
 * @return {Object}
 */
const branding = state => {
    return {
        logo: state.data.meta.company_resources.logo,
        primary_color: state.data.meta.company_resources.primary_color || '#173158',
        secondary_color: state.data.meta.company_resources.secondary_color || '#f5f5f5'
    }
}

export default {
    branding,
    hasSections
}



// WEBPACK FOOTER //
// ./src/state/modules/dom-alt/getters.js